import { Component, Input, Output, EventEmitter } from '@angular/core'

import { MessagesDelegate } from '../../services/messages-delegate.service'
import { GroupsService } from '../../services/groups.service'
import { UsersService } from '../../services/users.service'

import { Group } from '../../models/group.model'
import { User } from '../../models/user.model'

@Component({
  selector: 'ld-group-members',
  template: require('./group-members.component.html'),
  styles: [require('./group-members.component.css')]
})
export class GroupMembersComponent {
  @Input('group') group: Group = new Group()
  @Output('groupChange') groupChange = new EventEmitter<Group>()
  private selectedUser = new User()

  constructor (
    private groupsService: GroupsService,
    private usersService: UsersService,
    private messagesDelegate: MessagesDelegate) {}

  async addFilteredUser (user) {
    this.group = await this.groupsService.addUser({
        id: this.group.id,
        userId: this.selectedUser.id
      })
      .catch((e) => {
        this.messagesDelegate.add(e.message)
        return this.group
      })

    this.selectedUser = new User()
    this.groupChange.emit(this.group)
  }

  clearSelection () {
    this.selectedUser = new User()
  }

  isSelectedUserInGroup () {
    return this.group.users.find(u => u.id === this.selectedUser.id)
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/components/group-members/group-members.component.ts